import React from 'react';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { SignalTileDataState } from 'widgets/signalTiles/signalTile/state/stream/SignalTileStreamState';
import { AnySeries } from '@d3fc/d3fc-series';
import { SignalTileChart } from 'widgets/signalTiles/signalTile/components/chart/SignalTileChart';

interface SignalTileContentProps {
    config: SignalTileConfigState;
    streamData: SignalTileDataState | undefined;
    domain: [number, number];
    series: AnySeries;
    upperBoundary: number;
    lowerBoundary: number;
    className: string;
}

export function SignalTileContent(props: SignalTileContentProps) {
    const { className, streamData } = props;

    if (!props.streamData) {
        return <div className={className}>No data</div>;
    }

    return (
        <div className={className}>
            <SignalTileChart {...props} streamData={streamData!} />
        </div>
    );
}
